/**
 * Offer Question Bank — thin wrapper over the shared ChecklistBankPage.
 * Sprint 11.6 (#10), MVP scope: questions + red flags used during the offer
 * conversation. No difficulty field (offer questions don't grade).
 * Taxonomy matches Panel (Industry → Department → Role + department_id).
 * CSV bulk upload mirrors Panel (without difficulty columns).
 */
import React from 'react';
import { ChecklistBankPage } from './ChecklistBankPage';

export default function OfferBank() {
  return (
    <ChecklistBankPage
      pageTitle="Offer Questions &amp; Red Flags"
      pageSubtitle="Master checklist for offer conversations, scoped by Industry → Department → Role. Capture model answers and red flags HR should listen for. Auto-saves on blur."
      apiPath="/questions/offer"
      queryKey={['v1-offer-qs']}
      withDifficulty={false}
      showBulkUpload
      bulkKind="offer"
      testIdPrefix="offer-bank"
      editPermission="bank.offer.edit"
    />
  );
}
